import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getUserData } from '../../_actions';
import ErrorPage, { ErrorPageNoneAuth } from '../error';

const PageNotFound = () => {
  return <ErrorPage code={404} />;
};

export const PageNotFoundUnauthorise = ({ history }) => {
  useEffect(() => {
    const user = getUserData();
    if (user.logged_in) {
      if (history) {
        history.push('/404');
      }
    }
    // eslint-disable-next-line
  }, []);
  return <ErrorPageNoneAuth code={404} />;
};

PageNotFoundUnauthorise.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired
};

PageNotFound.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func
  }).isRequired
};

export default PageNotFound;
